import React, { useState, useEffect } from 'react'
import { NavLink, Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const apiUrl = apiBaseUrl+`footerinfo`;
  const [data, setData] = useState('');
  const [newsletterData, setNewsletterData] = useState('');
  const [email, setEmail] = useState("");
  const[msg, setMsg] = useState({});
  const [errors, setErrors] = useState({});

  //console.log(location.pathname);

  // Validation function for email and password
  const validateForm = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Please enter a valid email address";
    }
    return errors;
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const postData = {
        email:email
    };
 
    await axios.post(apiBaseUrl + "subscribe", postData).then((res)=>{
      //console.log('Uer Details:', res);
      setMsg(res.data);
      if (res.data.success === true) {
        toast("Thank you for your subscription.");
      }else {
        toast("You have already subscribed with us");
      }        
    })
    .catch((err)=>{
      //console.log('Invalid Email :', err);
      setMsg({msg: "Subscription failed"});
      toast("Subscription failed");
    })
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  };

  const fetchFooterInfo = () => {
    return axios.get(apiUrl).then((res) => {
      setData(res.data.company);
      setNewsletterData(res.data.newsletterwidget);
    });
  };

  useEffect(() => {
    setTimeout(() => {
      fetchFooterInfo();
    }, 3000);
  }, []);

  return (
  <>
  <ToastContainer />  

  <section className="section-content-block1 newsletter"> 
			<div className="container">
				<div className="row">
					<div className="col-sm-5 col-12">
						<h3>{newsletterData?.heading}</h3>
						<p>{newsletterData?.description}</p>
					</div>
					<div className="col-sm-7 col-12 mob-device text-right">
						  <form 
                className="news-form"
                onSubmit={handleSubmit}>
                <div className="input-group1 ">
                    <input 
                      className="" 
                      placeholder="Enter your email" 
                      type="email" 
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      autoComplete="false"
                      required
                    />
                    {errors.email && <span className="error-message">{errors.email}</span>}
                    <button type='submit' className="submit">Subscribe</button>
                    {msg.success === true && <div className="text-success text-center"><br />{msg.message}</div>}
                    {msg.success === false && <div className="text-danger text-center"><br />{msg.message}</div>}
                </div>
              </form>
					</div>
					
				</div>
			</div>
	
	</section>

  <footer>            
    <section className="footer-widget-area footer-widget-area-bg">
        <div className="container">                    
            <div className="row">	
                <div className="col-md-4 col-sm-12 col-xs-12">
                    <div className="footer-widget">
                        <div className="sidebar-widget-wrapper">
                            <div className="textwidget about-footer"> 
                              <figure className="margin-top-12 margin-bottom-12">
                                <Link to="/" className='logo'>
                                    <img alt={data?.company_name} src="/images/logo.png" />
                                </Link>                                
                              </figure>     
                            </div>
                        </div>
                    </div>
                </div>                  
                <div className="col-md-8 col-sm-12 col-xs-12">
                  <div className="row">
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="footer-widget clearfix">
                          <div className="sidebar-widget-wrapper">
                              <div className="footer-widget-header clearfix">
                                  <h3>Product</h3>
                              </div>
                              <ul className="footer-useful-links">
                                  <li><NavLink to='/product/solar-module' onClick={scrollToTop}> Solar Module</NavLink></li>
                                  <li><NavLink to='/product/solar-cell' onClick={scrollToTop}> Solar Cell</NavLink></li>
                                  <li><NavLink to='/product/mounting-structure' onClick={scrollToTop}> Mounting Structure</NavLink></li>                                
                               </ul>
                          </div>         
                      </div>
                    </div>
                    
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="footer-widget clearfix">
                          <div className="sidebar-widget-wrapper">
                            <div className="footer-widget-header clearfix">
                                <h3>Solutions</h3>
                            </div>
                            <ul className="footer-useful-links">
                                <li><NavLink to="/solution/section/residential" onClick={scrollToTop}> Residential</NavLink></li>
                                <li><NavLink to="/solution/section/housing" onClick={scrollToTop}> Housing Societies</NavLink></li>
                                <li><NavLink to="/solution/section/ci" onClick={scrollToTop}> C&I</NavLink></li>
                                <li><NavLink to="/solution/section/institutional" onClick={scrollToTop}> Institutional</NavLink></li>
                                <li><NavLink to="/solution/section/powerplants" onClick={scrollToTop}> Mega Power Plants</NavLink></li>
                                <li><NavLink to="/solution/section/aftercare" onClick={scrollToTop}> After Care</NavLink></li>   
                            </ul>
                          </div>         
                      </div>
                    </div>
                    
                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="footer-widget clearfix">
                        <div className="sidebar-widget-wrapper">
                          <div className="footer-widget-header clearfix">
                              <h3>Company</h3>
                          </div>
                          <ul className="footer-useful-links">
                            <li><NavLink to="/about-us" onClick={scrollToTop}> About Us</NavLink></li>
                            <li><NavLink to="/download-certificates" onClick={scrollToTop}> Downloads</NavLink></li>
                            <li><NavLink to="/contact" onClick={scrollToTop}> Contact Us</NavLink></li>
                            <li><NavLink to="/careers" onClick={scrollToTop}> Career</NavLink></li>
                            <li><NavLink to="/blog" onClick={scrollToTop}> Blog</NavLink></li>
                          </ul>
                        </div>         
                      </div>
                    </div>

                    <div className="col-md-3 col-sm-12 col-xs-12">
                      <div className="footer-widget clearfix">
                        <div className="sidebar-widget-wrapper">
                          <div className="footer-widget-header clearfix">
                              <h3>Legal</h3>
                          </div>
                          <ul className="footer-useful-links">
                            <li><NavLink to="/term-condition" onClick={scrollToTop}> Terms</NavLink></li>
                            <li><NavLink to="/privacy-policy" onClick={scrollToTop}> Privacy</NavLink></li>
                          </ul>
                        </div>         
                      </div>
                    </div>
                      
                  </div>
                </div>
            </div>

        </div>
    </section> 
    <div className="container"><hr/></div>
    <section className="footer-contents">
        <div className="container">
            <div className="row clearfix">
                <div className="col-md-8 col-sm-12 text-right clearfix">
                  <p className="copyright-text"> Copyright &copy; Junna Solar Systems Limited. All Rights Reserved. </p>
                </div>
                <div className="col-md-4 col-sm-12 mob-device text-right clearfix">
                    <div className="social-icons">
                      <Link to={data?.linkedin} target="_blank"><i className="fa fa-linkedin-square"></i></Link>
                      <Link to={data?.facebook} target="_blank"><i className="fa fa-facebook-square"></i></Link>
                      <Link to={data?.twitter} target="_blank">
                        <img alt={data?.company_name} src="/images/twitter.png" />
                      </Link>
                      <Link to={data?.instagram} target="_blank"><i className="fa fa-instagram"></i></Link>
                      <Link to={data?.youtube} target="_blank"><i className="fa fa-youtube-play"></i></Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </footer>


</>    
  )
}

export default Footer